import { formatarValorMonetarioInputNumerico } from "shared/util/functions/formatacoesDeValores/FormatarValores";
import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import * as yup from "yup";

export const ModalCadastrarDespesaParceladaGroupPaySchema = yup.object().shape({
  valorTotal: yup
    .number()
    .transform((_, originalValue) => {
      let valor = originalValue ? originalValue : "0";
      return typeof valor === "number" ? valor : formatarValorMonetarioInputNumerico(valor);
    })
    .min(0.01, "O valor total deve ser maior do que 0.01!")
    .required(mensagemDeErroPadrao("Valor total")),

  numeroParcelas: yup
    .number()
    .transform((_, originalValue) => {
      let valor = originalValue ? originalValue : "0";
      return typeof valor === "number" ? valor : formatarValorMonetarioInputNumerico(valor);
    })
    .min(1, "O número de parcelas deve ser maior que 0!")
    .required(mensagemDeErroPadrao("Número de parcelas")),

  dataVencimentoPrimeiraParcela: yup
    .date()
    .required(mensagemDeErroPadrao("Data de vencimento da primeira parcela"))
    .typeError("Informe uma data válida"),
});
